import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { LoginComponent } from './Components/login/login.component';
import { HomeComponent } from './Components/home/home.component';
import { LocationComponent } from './Components/location/location.component';
import { SuiModule } from 'ng2-semantic-ui';
import { BikesComponent } from './Components/bikes/bikes.component';
import { BooksComponent } from './Components/books/books.component';
import { SettingsModule} from './settings/settings.module';

import { PostService } from "./Services/post.service";
import { GetService } from "./Services/get.service";
import { InventoryService} from './Services/inventory.service';
import { UrlManagerService } from "./Services/url-manager.service";
import { LoginService } from "./Services/login.service";

import {AuthGuard} from './admin.auth.service';

import {AdminModule} from './admin/admin.module';

import {LocationService} from './Services/location.service';
import {ChildModalComponent} from './shared/components/childModal/childModal.component';


import {enableProdMode} from '@angular/core';
enableProdMode();

const appRoutes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'donor', loadChildren: 'app/donor/donor.module#DonorModule', pathMatch:'prefix' },
  { path: 'family', loadChildren: 'app/family/family.module#FamilyModule', pathMatch: 'prefix'},
  { path: 'location', component: LocationComponent },
  { path: 'login', component: LoginComponent },
  { path: 'home', component: HomeComponent },
  { path: 'tools', loadChildren: 'app/tools/tools.module#ToolsModule' },
  { path: 'bikes', component: BikesComponent },
  { path: 'books', component: BooksComponent },
  { path: 'settings', loadChildren: 'app/settings/settings.module#SettingsModule' },
  { path: 'admin', loadChildren: 'app/admin/admin.module#AdminModule', canActivate: [AuthGuard]}
];
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    LocationComponent,
    BikesComponent,
    BooksComponent,
    ChildModalComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes, {useHash: true}),
    SuiModule,
    HttpModule,
    FormsModule
  ],
  providers: [PostService, GetService, UrlManagerService, LoginService, AuthGuard, LocationService, InventoryService],
  bootstrap: [AppComponent],
  entryComponents: [ChildModalComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts